import {
  FeaturesSection,
  FeaturesType,
} from "../../../api/services/client/models";
import { OptionsDataType } from "../../../components";
import { GENERIC_ACCOUNT_FEATURE_TYPES } from "../../../helpers/constants";
import { isEmpty } from "../../../helpers/utils";
import { createGenericAccounts } from "./siteCore/SiteCoreKeys";

export const SECTION_CONFIG: Array<{
  match: { type?: string; name?: string };
  headingKey: string;
}> = [
  {
    match: { type: GENERIC_ACCOUNT_FEATURE_TYPES.TOOL },
    headingKey: createGenericAccounts.toolsSubHeading,
  },
  {
    match: { type: GENERIC_ACCOUNT_FEATURE_TYPES.ASSESSMENT },
    headingKey: createGenericAccounts.assessmentsAndTasksSubHeading,
  },
  // events + docebo share the same heading:
  {
    match: { name: GENERIC_ACCOUNT_FEATURE_TYPES.EVENTS_PAGE },
    headingKey: createGenericAccounts.eventsAndWebinarsSubHeading,
  },
  {
    match: { name: GENERIC_ACCOUNT_FEATURE_TYPES.DOCEBO_TILE },
    headingKey: createGenericAccounts.eventsAndWebinarsSubHeading,
  },
  {
    match: { name: GENERIC_ACCOUNT_FEATURE_TYPES.MY_COACH_PAGE },
    headingKey: createGenericAccounts.coachMeetingSubHeading,
  },
];

export const getFeaturesByMatch = (
  list: FeaturesType[],
  match: { type?: string; name?: string },
  isChecked = true,
) => {
  if (!list || isEmpty(list)) {
    return [];
  }
  return list
    .filter((item) =>
      match.type
        ? item.type === match.type
        : match.name
          ? item.name === match.name
          : false,
    )
    .map((item) => ({ ...item, isChecked }));
};

export const mapNamesToKey = (combinedSiteCoreList: OptionsDataType[]) => {
  // build a lookup from your key→value array
  //    mappingData: Array<{ key: string; value: string }>
  const mappedNamesData = Object.fromEntries(
    combinedSiteCoreList.map(({ label, value }: OptionsDataType) => [
      value,
      label,
    ]),
  ) as Record<string, string>;

  return mappedNamesData;
};

export const flatArrayAndMapNamesToSiteCore = (
  array: FeaturesSection[],
  combinedSiteCoreList: OptionsDataType[],
) => {
  return array.flatMap(({ title, items }) =>
    items.map((item) => ({
      ...item,
      name: mapNamesToKey(combinedSiteCoreList)[item.siteCoreKey] ?? item.name,
      sectionTitle: title ?? "",
    })),
  );
};
